import React, { useState, useEffect } from "react";

export function convertUnicodeToEmoji(emojiUnicode) {
  try {
    return String.fromCodePoint(parseInt(emojiUnicode, 16));
  } catch (e) {
    return null;
  }
}
